import { MatSnackBarConfig } from "@angular/material/snack-bar";

export interface BaseClass {
  id: string;
  segmentId: string;
  createdDate: number;
  createdBy: string;
  createdByName?: string;
  updatedDate: number;
  updatedBy: string;
  updatedByName?: string;
}

export const errorMsgConfig: MatSnackBarConfig = {duration: 81 * 1000, panelClass: ['snackbar-error']}

export interface QuestionAnswerPairsPublic {
  id?: string;
  question?: {
    id: string;
    displayLabel: string;
    sortOrder: number;
    displayOnListing: boolean;
  }
  answerText?: string;
  answerValues:string[];
  isSearchable?: boolean;
  isDisplayable?: boolean;
}

export interface Answer {
  id: string;
  answerText: string;
  answerValues: string[];
}

export type QuestionTypeEnum = "TEXT" | "SINGLE_SELECT" | "MULTI_SELECT"
export const dateTimeFormat = "MMM d, yyyy h:mma"


export type StatusObjectType =
  "USERS"
 | "LOCATIONS"
 | "LISTINGS"
 | "ORDERS"
 | "FULFILLMENTS"
 | "REFUNDS"
 | "PROCESSORS"
 | "CATEGORIES"
 | "SEGMENTS"
 | "IMAGES"
 | "DISCOUNTS"
 | "INTERACTIONS"
 | "MESSAGES"
 | "PAYOUTS"

export interface Status {
  id: string
  label: string
  description: string
  for: StatusObjectType[]
  timeUntilNextAction: number
  sortOrder: number
}